export default __webpack_public_path__ + "static/media/ms-net.b4a1f214.svg";